import React, { useEffect, useState } from 'react';
import { ForgotPasswordVerificationForm } from '../../components/forms';

const ForgetPasswordVerificationPage: React.FC = () => {
  const [userEmail, setUserEmail] = useState<string>('');

  useEffect(() => {
    if (localStorage.getItem('user-email')) {
      setUserEmail(localStorage.getItem('user-email') || '');
    }
  }, []);

  return (
    <div className='h-full flex flex-col justify-center w-full max-w-[27.5rem] mx-auto py-12'>
      <h2 className='!text-4xl !font-medium mb-1 text-secondary-500'>
        Verification Code Required
      </h2>
      <p className='text-sm mb-6'>
        Kindly enter the verification code that we have sent to{' '}
        <span className='text-theme-blue-700'>{userEmail}</span>.
      </p>

      <ForgotPasswordVerificationForm />
    </div>
  );
};

export default ForgetPasswordVerificationPage;
